import { AuditLogResponseData } from '../../hooks/use-audit-log';
import { useStores } from '../../hooks/use-stores';
import React, {
  useMemo,
  useState,
} from 'react';
import { displayDate } from '../../utils/date';
import { AuditLogDataChangeEntry } from './AuditLogDataChangeEntry';
import { modifyItem } from './AuditLogHelper';

export const AuditLogRow = (props: {item: AuditLogResponseData['items'][0]}) => {
  const {settingsStore} = useStores();
  const {item} = props;
  const [isAccordionActive, setIsAccordionActive] = useState(false);

  if (item.actionType === 'Update') {
    modifyItem(item);
  }

  const handleClickAccordionTitle = () => {
    setIsAccordionActive(!isAccordionActive);
  };

  const auditLogChangeObject = useMemo(() => {
    if (item.actionType === 'Update') {
      return item.details.from;
    }
    return item.details;
  }, [item.actionType, item.details]);

  return (
    <>
      <tr
        className={isAccordionActive ? 'audit-log-table-row-main--active audit-log-table-row-main' : 'audit-log-table-row-main'}
        onClick={handleClickAccordionTitle}
      >
        <td>
          {isAccordionActive ? (
            <i className={'fa fa-fw fa-chevron-down'}></i>
          ) : (
            <i className={'fa fa-fw fa-chevron-right'}></i>
          )}
        </td>
        { settingsStore.configuration && (
          <td>
            {displayDate(item.actionDate, settingsStore.configuration.ianaTimeZone)}
          </td>
        )}
        <td>
          {item.userEmail}
        </td>
      </tr>
      {isAccordionActive && (
        <tr>
          <td
            colSpan={3}
          >
            <div
              className={'audit-log-data-content-container'}
            >
              <div
                className={'audit-log-data-content'}
              >
                {Object.entries(auditLogChangeObject).map(([key, value]) => (
                  <AuditLogDataChangeEntry
                    key={`change-entry-${key}`}
                    propertyKey={key}
                    propertyValue={value}
                    item={item}
                  />
                ))}
              </div>
            </div>
          </td>
        </tr>
      )}
    </>
  );
};
